'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var Device = function Device(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 26 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 26 : _ref$width;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-device ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('rect', { width: '18', height: '22', x: '4', y: '2', fill: color, rx: '2' }),
      _react2.default.createElement('rect', { width: '14', height: '16', x: '6', y: '4', fill: '#FFF' }),
      _react2.default.createElement('circle', { cx: '13', cy: '22', r: '1', fill: '#FFF' })
    )
  );
};

Device.propTypes = _bcPropTypes.iconShape;

exports.default = Device;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Device/Device.js
// module id = 170
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14